module.exports = __webpack_public_path__ + "assets/TB_Dashboard_Graph_hamburger-24px.svg";